(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sft-magic-demo"] && !Shopify.designMode) return;
  try {
    (() => {
if(customElements.get('sft-magic-explorer'))return;
customElements.define('sft-magic-explorer',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.mode=this.dataset.initialMode||'weather';this.terrain='road';this.color='clear';
this.range=this.querySelector('.mx-range');this.skies=[...this.querySelectorAll('.mx-sky')];
this.states={day:[...this.querySelectorAll('[data-state-mode="day"]')],weather:[...this.querySelectorAll('[data-state-mode="weather"]')]};
this.range.addEventListener('input',()=>this.update());
this.querySelectorAll('[data-mode]').forEach(b=>b.addEventListener('click',()=>{this.mode=b.dataset.mode;this.update();}));

this.querySelectorAll('[data-color]').forEach(b=>b.addEventListener('click',()=>{this.color=b.dataset.color;this.update();}));
this.update();}
update(){
const v=Number(this.range.value),p=v/100,tint=this.mode==='day'?1-p:p;
this.style.setProperty('--tint',tint);
this.style.setProperty('--lens-color','rgb('+[222,233,239].map((c,i)=>Math.round(c+([31,37,41][i]-c)*tint)).join(',')+')');
this.style.setProperty('--track-start',this.mode==='day'?'#1f2529':'#dee9ef');
this.style.setProperty('--track-end',this.mode==='day'?'#dee9ef':'#1f2529');this.style.setProperty('--progress',p);
const idx=v<34?0:v<67?1:2,state=this.states[this.mode][idx];
this.querySelector('[data-weather]').textContent=state.dataset.label;
this.querySelector('[data-icon]').textContent=this.mode==='day'?['☀','◒','☾'][idx]:['☁','⛅','☀'][idx];
let lensLabel=state.dataset.lens;
const colorButton=this.querySelector('[data-color="'+this.color+'"]');
if(colorButton){
this.style.setProperty('--reflection-color',{clear:'transparent',red:'#f6a137',blue:'#49c4ed'}[this.color]);
this.querySelectorAll('[data-lens-image]').forEach(i=>i.hidden=i.dataset.lensImage!==this.color);
this.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.color===this.color)));
this.querySelector('[data-color-note]').textContent=colorButton.dataset.note;
if(this.color!=='clear')lensLabel=tint<.5?colorButton.dataset.light:colorButton.dataset.dark;
const palette={clear:[[222,233,239],[31,37,41]],red:[[250,214,191],[223,61,35]],blue:[[202,235,241],[18,136,206]]}[this.color];
this.style.setProperty('--lens-color','rgb('+palette[0].map((c,i)=>Math.round(c+(palette[1][i]-c)*tint)).join(',')+')');
const light='rgb('+palette[0].join(',')+')',dark='rgb('+palette[1].join(',')+')';
this.style.setProperty('--track-start',this.mode==='day'?dark:light);
this.style.setProperty('--track-end',this.mode==='day'?light:dark);
}
this.querySelector('[data-lens]').textContent=lensLabel;
this.range.setAttribute('aria-valuetext',state.dataset.label+', '+lensLabel+', '+state.dataset.uv);
this.querySelector('[data-slider-label]').textContent=this.mode==='day'?this.dataset.dayLabel:this.dataset.weatherLabel;
this.querySelector('[data-start]').textContent=this.states[this.mode][0].dataset.endpoint;
this.querySelector('[data-end]').textContent=this.states[this.mode][2].dataset.endpoint;
this.querySelector('[data-start-icon]').textContent=this.mode==='day'?'☀':'☁';
this.querySelector('[data-end-icon]').textContent=this.mode==='day'?'☾':'☀';
const weights=this.mode==='day'?{day:1,sunset:Math.min(1,p*2),night:Math.max(0,p*2-1),cloud:0}:{cloud:1,day:p,sunset:0,night:0};
this.skies.forEach(i=>i.style.opacity=i.dataset.terrain===this.terrain?weights[i.dataset.sky]:0);
this.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mode===this.mode)));

}
});})();
  } catch(e) { console.error(e); }
})();

})();
